// src/data/paintingJury.js
// Data list for the National Environmental Painting Competition jury panel.
// Add new members by appending another object to this array — the section
// and modal on the Upcoming Engagements page will pick them up automatically.

export const paintingJury = [
  {
    id: "ashok-kumar-biswas",
    name: "Ashok Kumar Biswas",
    designation: "Padma Shri Awardee",
    subDesignation: "Tikuli Painting, Bihar",
    image: "/images/painting-jury/ashok-kumar-biswas.jpeg",
    shortBio:
      "Padma Shri awardee credited with reviving Bihar's centuries-old Tikuli Painting art form, and a lifelong advocate for women's empowerment through craft training.",
    profile:
      "Shri Ashok Kumar Biswas has dedicated over 50 years to reviving Tikuli Painting — an art form dating back to the Mauryan era. Trained at the Shilp Anusandhan Sansthan in 1973, he transformed the craft's future, introducing around 1000 new designs while sending over 20 lakh pieces of Tikuli art across the globe. His work stands at the intersection of cultural heritage, innovation and social impact.",
    education: [
      "Trained under Shri Lal Babu Gupta, Shilp Anusandhan Sansthan (1973)",
    ],
    experience: [
      "50+ Years reviving and popularizing Tikuli Painting",
      "Core Faculty in Tikuli Painting, MSME, Ministry of MSME, Govt. of India",
      "Empanelled Faculty, UMSAS, Government of Bihar",
    ],
    highlights: [
      "Padma Shri, Government of India — 2024",
      "Trained 9,000+ women free of cost over 52 years, empowering them as self-enterprising artisans",
      "Creation chosen as the official gift for international athletes at the 1982 Asian Games",
      "Represented India at international exhibitions in Bhutan, Mauritius, Spain, London & South Korea",
      "Art housed at the Bihar Museum, Patna, and gifted by Rashtrapati Bhawan at the 79th Independence Day 'At Home', 2025",
    ],
  },
  {
    id: "joydeep-das-gupta",
    name: "Dr. Joydeep Das Gupta",
    designation: "Former Subject Expert, University of Lucknow",
    subDesignation: "Visiting Faculty, Amity University Lucknow & Goel Group of Institutions Lucknow",
    image: "/images/painting-jury/joydeep-das-gupta.png",
    shortBio:
      "Ph.D in Indian Sculpture & Iconography (B.H.U.) with 25+ years of teaching experience, and an Art Historian & Aesthetician.",
    profile:
      "A focused, result-oriented and diligent academic with innovative teaching skills, Dr. Das Gupta brings a positive, inquisitive approach to art education and has contributed extensively to the study of Indian art history and iconography.",
    education: [
      "Ph.D in Indian Sculpture & Iconography, Banaras Hindu University (2002)",
      "M.A. (Art History), BHU — Order of Merit, 1st in University (1991)",
      "B.F.A (Applied Arts), BHU (1989)",
      "Art Historian & Aesthetician",
    ],
    experience: [
      "25+ Years of Teaching Experience",
      "Former Assistant Professor, Amity University Lucknow (2008–2022)",
      "Former Subject Expert, College of Arts & Crafts, University of Lucknow (2022–2024)",
    ],
    highlights: [
      "National & International Seminar Speaker, with numerous research papers & presentations",
    ],
  },
  {
    id: "jasminder-kaur",
    name: "Jasminder Kaur",
    designation: "Professor, Textile Designing",
    subDesignation: "Head, Department of Painting, Faculty of Visual Arts, BHU",
    image: "/images/painting-jury/jasminder-kaur.jpeg",
    shortBio:
      "Professor of Textile Designing at BHU with 20+ years of experience in teaching, design practice and research, honoured by the Government of India at Lakme Fashion Week 2015.",
    profile:
      "Jasminder Kaur bridges tradition and experimentation in her artistic practice, reinterpreting craft techniques such as block printing and Bandhej through a contemporary visual language. Her acclaimed solo exhibitions — Kalpvriksha I, II & III and Recreating Bandhej I, II & III — explore texture, resist-dyeing, symbolism and conceptual narratives rooted in nature, spirituality and cultural continuity.",
    education: [
      "Extensive academic and design practice background in Textile Design",
    ],
    experience: [
      "Head, Department of Painting, Faculty of Visual Arts, Banaras Hindu University",
      "20+ Years of Experience in Teaching, Design Practice & Research",
      "Former Visiting Faculty at leading institutions",
    ],
    highlights: [
      "Honoured by the Government of India at Lakme Fashion Week, 2015, for reviving traditional weaving & handloom technology",
      "Solo exhibitions: Kalpvriksha I, II & III and Recreating Bandhej I, II & III",
      "Exhibited at Lalit Kala Akademi and across Varanasi, Delhi, Jaipur, Bengaluru, Chandigarh, Amritsar & Lucknow",
      "Presented research internationally in the UK and Portugal; published 30+ research papers",
    ],
  },
  {
    id: "varun-sahai",
    name: "Dr. Varun Sahai",
    designation: "Associate Professor, Fine Arts",
    subDesignation: "Amity School of Fine Arts, Amity University, Noida",
    image: "/images/painting-jury/varun-sahai.jpg",
    shortBio:
      "Associate Professor with 18+ years of experience in Animation & Design, and Programme Coordinator at Amity School of Fine Arts, Amity University.",
    profile:
      "Dr. Sahai is an enthusiastic and insightful academic driving Fine Arts curriculum development and delivery, known for implementing technology-based teaching methods and fostering student success. He is an active researcher, author and conference organizer in the field of Animation & Design.",
    education: [
      "Ph.D, Amity School of Fine Arts, Amity University — Impact of Animated Characters on Learning of Children (2024)",
      "UGC NET (2021)",
      "M.Sc. (Multimedia & Animation), Himalayan University (2015)",
    ],
    experience: [
      "18+ Years of Experience as Core Faculty of Animation & Design",
      "Associate Professor, Amity University Noida (2025–Present)",
      "Programme Coordinator, Amity School of Fine Arts",
    ],
    highlights: [
      "Author, 'Mastering Character Animation for Modern Storytelling' (ISBN 978-81-687634-0-1)",
      "Published multiple UGC Care-listed research papers on animation, technology & Indian art forms",
      "Co-Convener, International Conference on Innovation in Visual Arts (ICIVA 2023, 2024)",
      "Academic associations with NCERT, Delhi University, Jamia Millia Islamia and other institutions",
    ],
  },
  {
    id: "meinam-irikhomba-meetei",
    name: "Meinam Irikhomba Meetei",
    designation: "Assistant Professor, Dept. of Fine Arts",
    subDesignation: "Manipur University",
    image: "/images/painting-jury/meinam-irikhomba-meetei.jpeg",
    shortBio:
      "Assistant Professor of Fine Arts at Manipur University and an award-winning artist recognized by multiple state and regional art bodies.",
    profile:
      "Meinam Irikhomba Meetei believes art can help us see a more compassionate and sustainable tomorrow, bringing that perspective to his teaching and practice across art, education, culture and the environment.",
    education: [
      "Department of Fine Arts, Manipur University",
    ],
    experience: [
      "Assistant Professor, Department of Fine Arts, Manipur University",
    ],
    highlights: [
      "Art Society Manipur Annual Art Award (ASMAAA), 2025",
      "2nd M.K. Priyobrata Singh Memorial Award, 2016 — Manipur Cultural Integration Conference & Art Society Manipur",
      "Art Society Manipur Annual Art Award (ASMAAA), 2017",
      "Dwijendra–Doli Memorial Trust Prize, 2009, Silchar, Assam",
      "1st Position in Cartooning, Eastern Zonal Youth Festival (A.I.U.), 2003, Vinoba Bhave University, Jharkhand",
    ],
  },

  {
    id: "saday-c-das",
    name: "Dr. Saday C Das",
    designation: "Associate Professor, Department of Visual Arts",
    subDesignation: "Assam University, Silchar",
    image: "/images/painting-jury/saday-c-das.jpeg",
    shortBio:
      "Associate Professor with 20+ years of teaching experience in Visual Arts, and an active researcher and resource person at national and international seminars.",
    profile:
      "Dr. Saday C Das holds that art has the power to awaken awareness, inspire action and shape a greener tomorrow — a philosophy reflected in his teaching, research and extensive exhibition record across India and abroad.",
    education: [
      "Ph.D in Graffiti and Its Relevance, Assam University (2014)",
      "MFA & BFA in Painting, Department of Visual Arts, Assam University, Silchar",
    ],
    experience: [
      "Associate Professor, Department of Visual Arts, Assam University, Silchar",
      "20+ Years of Teaching Experience in Visual Arts and Art Education",
      "Visual Arts & Art History Researcher with a focus on contemporary art practices",
    ],
    highlights: [
      "Resource Person and Paper Presenter at National and International Seminars, Conferences and Academic Programmes",
      "Contributor to research publications in Visual Arts and Art History",
      "Member of various Academic and Statutory Bodies",
      "Participated in numerous national and international exhibitions, with artworks held in collections in India and abroad",
    ],
  },

  {
    id: "subrata-dey",
    name: "Dr. Subrata Dey",
    designation: "Assistant Professor, Department of Fine Arts",
    subDesignation: "Tripura University (A Central University), Suryamaninagar, Agartala",
    image: "/images/painting-jury/subrata-day.jpeg",
    shortBio:
      "Assistant Professor of Fine Arts at Tripura University, a multiple-time Best Artist awardee with a strong record in both art and research workshops.",
    profile:
      "Dr. Subrata Dey believes art and research together can build a more sensitive and sustainable tomorrow, an ethos reflected in his participation across research-technology workshops and art residencies in India and Bangladesh.",
    education: [
      "Department of Fine Arts, Tripura University, A Central University",
    ],
    experience: [
      "Assistant Professor, Department of Fine Arts, Tripura University",
    ],
    highlights: [
      "Best Artist Award, Tripura Rabindra Parishad, Agartala — 2002, 2000, 1999",
      "National Workshop on Emerging Tools and Technologies in Research (ETTR-2020), Tripura University",
      "Faculty Development Programme on Recent Trends in Electronics and Information Technology (RTEIT-2020)",
      "All Media Camp preparatory workshop for XII Triennale at Lalit Kala Akademi, Kolkata (2013)",
      "Indo-Bangla Public Art Workshop, Chobirhat, Shabagh, Dhaka, Bangladesh (2012)",
    ],
  }, 
  {
    id: "gayatri-mathur",
    name: "Dr. Gayatri Mathur",
    designation: "Programme Officer — Conservation & Special Projects",
    subDesignation: "Lalit Kala Akademi, Ministry of Culture, Govt. of India",
    image: "/images/painting-jury/gayatri-mathur.jpeg",
    shortBio:
      "Programme Officer at the Lalit Kala Akademi specializing in Women, Gender & Contemporary Art and international cultural diplomacy, with curatorial work spanning Mauritius and Germany.",
    profile:
      "Dr. Gayatri Mathur believes art has the power to build a more inclusive, compassionate and sustainable world — a conviction reflected in her curatorial advocacy for women artists and her work fostering government-to-government cultural exchange.",
    education: [
      "Specialization in Women, Gender & Contemporary Art and International Cultural Diplomacy",
    ],
    experience: [
      "Programme Officer — Conservation & Special Projects, Lalit Kala Akademi, Ministry of Culture, Govt. of India",
    ],
    highlights: [
      "Core specialization: Women, Gender & Contemporary Art — curatorial advocacy, feminist art historiography, cross-border women artists' collectives, and archival equity",
      "Core specialization: International Cultural Diplomacy — bilateral & multilateral exhibitions, state residencies, government-to-government MoUs",
      "Curatorial project on the Indian diaspora, Mauritius — Indenture Village (2012)",
      "Curated 'Moderns: Contemporary Indian Artists' showcase, Germany (2012)",
      "ICCR International Travel Grant recipient",
      "Veerangana Rani Laxmi Bai Gaurav Samman — for contribution to art, culture and women empowerment",
    ],
  },
];